import React from 'react';
import styled, { useTheme } from 'styled-components';
import Biometria from '../components/Biometria';
import Lottie from "lottie-react";
import BiometriaImg from "../assets/verification.json";

import Spacer from '../components/Spacer';
import Button from '../components/Button';

import { useLocation } from 'react-router-dom';
import { useDni } from '../DniContext';


const Wrapper = styled.div`
  height: 100vh;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 36px;
  padding-bottom: 100px;
`;



const MainText = styled.div`
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.basic2000};
`;

const Subtext = styled.h4`
  font-size: 18px;
  line-height: 26px;
  font-weight: 400;
  margin: 0 0 40px 0;
  text-align: center;
  width: 80%;

  @media (orientation: portrait) and (max-width: 767px) {
    width: 100%;
  }
`;




const BiometriaScreen = () => {
  return (
    <Wrapper>
      <Lottie animationData={BiometriaImg} style={{ width: '200px' }} />
      <MainText>Verificá tu identidad</MainText>
      <Biometria  />
      <Spacer size={80} />
    </Wrapper>
  )
};

export default BiometriaScreen;
